import { useContext, useCallback } from 'react';
import { StudyActorContext } from './StudyPhaseProvider';

export const useStudyPhaseSend = () => {
  const actor = useContext(StudyActorContext);
  const sendPhaseEvent = useCallback(actor.send, [actor]);

  return { sendPhaseEvent };
};
